var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contents"},[_c('partner-register-basic-information',{attrs:{"partner":_vm.partnerInfo.partner}}),_c('partner-register-detail-information',{attrs:{"type":"copy"},on:{"register-partner":_vm.registerPartner}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }